<button mat-ripple class="o-backdrop__close-btn" (click)="close()">
  <fa-icon [icon]="['fas', 'times']"></fa-icon>
</button>

<div class="c-lightbox"
     [@fade]="animationState"
     (@fade.done)="animationDone()">

  <img class="c-lightbox__image"
       [src]="data.imageUrl"
       [alt]="data.alt">

</div>
